import { Theme, webLightTheme } from "@fluentui/react-components";

/** Shared page canvas used by every task-pane route. */
export const taskPaneBackground = {
  backgroundColor: "#f6f8fc",
  backgroundImage: "radial-gradient(circle at 100% 0%, rgba(59, 130, 246, 0.14), transparent 62%)",
  backgroundRepeat: "no-repeat",
} as const;

/** Shared Fluent theme for the Excel task pane. */
export const sourcestoneLightTheme: Theme = {
  ...webLightTheme,
  borderRadiusMedium: "8px",
};
